import { trans } from '@codebuild/cookie-jar/libs/translation/trans';
import { arrayToClass } from '@codebuild/cookie-jar/uikit/libs/array-to-class';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { RequestForgotPassword } from '../../components/authentication/forgot-password/request-forgot-password';
import { generateLink } from '../../libs/generate-link';
import { Subscribable } from '../../libs/subscribable';
import { HOME_PAGE, routes } from '../../routes';
import './forgot-password-request.screen.scss';

const logo = require('../../assets/images/selectivita-logo-symbol.svg');

export class ForgotPasswordRequestScreen extends Subscribable<any, any> {

    public render(): React.ReactNode {
        return <div className={'ForgotPasswordRequestScreen p-box'}>
            <div className="row flex-fill">
                <div className="col-xl-8 col-lg-10 col-md-14 col-24">
                    {this.renderForgotPasswordRequestBox()}
                </div>
            </div>
        </div>;
    }

    public renderForgotPasswordRequestBox() {
        const loginContainer = arrayToClass([
            ' palette--bgc-neutral-2 display-flex flex-column p-box',
            'ForgotPasswordRequestContainer'
        ]);
        return <div className={loginContainer}>
            {this.renderForgotPasswordRequestHeadLine()}
            <RequestForgotPassword/>
        </div>;
    }

    public renderForgotPasswordRequestHeadLine() {

        return <div className={'row mb-7'}>
            <a href={HOME_PAGE} className={'col-sm-10 col-24 text-decoration-none mb-sm-0 mb-7'}>
                <div className={'justify-content-start align-items-center display-flex flex-row'}>
                    <img src={logo} className={'Logo'} alt="logo"/>
                    <h2 className={'mb-0 ml-7'}>Selectivita</h2>
                </div>
            </a>
            <div className={'col-sm-14 col-24 justify-content-end align-items-sm-center align-items-center display-flex'}>
                <Link to={generateLink(routes.login)} className={'fs-large palette--c-blue-2 fw-bold text-decoration-none'}>{trans('forgotpsw.backbutton')}</Link>
            </div>
        </div>;
    }

}
